import { createAction } from '@reduxjs/toolkit';
export const FETCH_ANALYTIC_TEAM = 'FETCH_ANALYTIC_TEAM';
export const fetchAnalyticTeamAction = createAction(FETCH_ANALYTIC_TEAM);